"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (candles) {
    return candles.map(function (data) {
        return { quote: +data.open, epoch: +data.epoch };
    });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/ticks/ohlcToTicks.js
// module id = 606
// module chunks = 0